//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex'
import { mapState } from 'vuex'
import animationData from '~/assets/data/lottie/gator.json'
import Radar from '~/node_modules/radar-sdk-js'

export default {
  data() {
    return {
      orderType: 'pickup',
      placeholder: 'Search store, city, state, or zip',
      address: null,
      suggestions: [],
      showMap: false,
      defaultOptions: { animationData, loop: false },
      query: '',
      firstResult: null
    }
  },
  props: {
    blok: {
      type: Object,
      default: () => []
    }
  },
  mounted() {
    this.$store.commit('setOpaque', true)
    this.$store.commit('customer/resetDeliveryAddress')
    this.$store.commit('setLocationList', null)
    if(this.$route.query.search) {
      this.address = this.$route.query.search
      this.locationSearch({ address: this.address })
    }
    // Radar autofill
    Radar.initialize(process.env.RADAR_KEY)
    Radar.ui.autocomplete({
      container: 'autocomplete',
      responsive: true,
      placeholder: 'Search by city, state or zip',
      onSelection: (result) => {
        const position = {
          coords: {
            latitude: result.latitude,
            longitude: result.longitude
          }
        }
        this.getCoordinates(position)
      },
      onResults: (results) => {
        const coords = {
          lat: results[0].latitude,
          lng: results[0].longitude
        }
        this.firstResult = coords
      }
    })
    this.$nextTick(() => {
      document.addEventListener('keyup', (e) => {
        if (e.target.parentElement.parentElement.id == 'autocomplete') {
          this.query = e.target.value
        }
      })
    })
  },
  computed: {
    ...mapState([ 'allLocations', 'locationList' ]),
    photo() {
      if (this.$breakpoints.width < 900) {
        return this.blok.photo.filename
      } else {
        return this.blok.photo_mobile.filename
      }
    },
    isMobile() {
      return (this.$breakpoints.width < 900)
    }
  },
  methods: {
    ...mapActions([ 'locationSearch' ]),
    setOrderType(type) {
      this.$store.commit('customer/resetDeliveryAddress')
      this.$store.commit('setLocationList', null)
      if(type == 'delivery') {
        this.orderType = 'delivery'
        this.placeholder = 'Enter a delivery address'
      } else {
        this.suggestions = []
        this.orderType = 'pickup'
        this.placeholder = 'Search store, city, state, or zip'
      }
    },
    searchLocations() {
      if(this.orderType == 'pickup') {
        this.locationSearch({ address: this.address })
      }
    },
    async searchFirstResult() {
      if (this.firstResult) {
        await this.$api.findLocations(this.firstResult)
      }
    },
    geoLocate() {
      if(navigator.geolocation) {
        this.$store.commit('setLoading', true)
        navigator.geolocation.getCurrentPosition(this.getCoordinates, this.getCoordinatesError)
      } else {
        this.$store.commit('setErrors', ['Please enable location services and try again.'])
      }
    },
    getCoordinates(position) {
      let coords = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }
      this.$api.findLocations(coords)
    },
    getCoordinatesError() {
      this.$store.commit('setLoading', false)
      this.$store.commit('setErrors', ['We couldn’t locate you. Please enter your address.'])
    },
    handleKeyUp(e) {
      if(this.orderType == 'delivery' && e.key != 'Shift' && this.address.length > 4) {
        this.$axios({
          method: 'get',
          url: `${window.location.origin}/autocomplete`,
          params: {
            query: this.address
          }
        }).then(res => {
          this.suggestions = res.data.features
        }).catch(err => {
          this.resetAutocomplete()
        })
      }
    },
    resetAutocomplete() {
      this.suggestions = []
    },
    handleAnimation(anim) {
      this.anim = anim
      this.anim.play()
      setTimeout(() => {
        this.$emit('finishedAnimation')
      }, 200)
    },
  }
}
